import { createSelector } from 'reselect'

import viewTypes from 'helpers/enums/viewTypes'
import currentViewSelector from '../ui/currentViewSelector'

const matchingPairsStateSelector = state => state.matchingPairsCt
const gameStateSelector = state => state.game
const drawItStateSelector = state => state.drawIt

const isCurrentActivityModifiedSelector = createSelector(
	[
		currentViewSelector,
		drawItStateSelector,
		matchingPairsStateSelector,
		gameStateSelector,
	],
	(
		currentView,
		drawItState,
		matchingPairsState,
		gameState,
	) => {
		const viewsToIsModifiedActivity = {
			[viewTypes.TIME_TO_CLIMB_CREATION]: gameState.isModified,
			[viewTypes.TIME_TO_CLIMB_STANDALONE_CREATION]: gameState.isModified,
			[viewTypes.DRAW_IT_CREATION]: drawItState.isModified,
			[viewTypes.DRAW_IT_STANDALONE_CREATION]: drawItState.isModified,
			[viewTypes.MATCHING_PAIRS_CREATION]: matchingPairsState.isModified,
			[viewTypes.MATCHING_PAIRS_STANDALONE_CREATION]: matchingPairsState.isModified,
		}

		return viewsToIsModifiedActivity[currentView] || false
	}
)

export default isCurrentActivityModifiedSelector
